import InfiniteProgress from "components/_common/InfiniteProgress";
import React from "react";
import { useSelector } from "react-redux";
import reportSelectors from "redux/app/report/selectors";
import { IStore } from "redux/store";

const headers = ["S.No", "IMO Number", "Vessel Name", "Total Records"];

function Biofouling2Table() {
	const reportStore = useSelector((store: IStore) =>
		reportSelectors._getStore(store),
	);
	const data = reportSelectors.getBiofouling2FleetData(reportStore);
	const { isLoading } = reportSelectors.jobToLoadBiofouling2Data(reportStore);

	const handleExportCSV = () => {
		if (!data.length) return;

		const rows = data.map((row, index) =>
			[index + 1, row.imoNumber, row.vesselName, row.bfl2RecordCount]
				.map((val) => {
					const str = String(val);
					return str.includes(",") ? `"${str}"` : str;
				})
				.join(","),
		);

		const csvContent = [headers.join(","), ...rows].join("\n");
		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const link = document.createElement("a");
		const url = URL.createObjectURL(blob);
		link.setAttribute("href", url);
		link.setAttribute("download", "biofouling_2.csv");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	if (data.length === 0) {
		return (
			<div className="flex justify-center items-center mt-20">
				No data found
			</div>
		);
	}

	return (
		<div className="px-4">
			<div className="flex justify-end mb-4">
				<button
					className="p-3 px-6 py-1 mt-1 mr-1 text-base text-indigo-700 border border-indigo-600 rounded-sm outline-none ws-button-og"
					disabled={!data.length}
					title="Export data as CSV"
					onClick={handleExportCSV}
				>
					<span className="mr-3 text-sm">Export Data</span>
					<span className="mb-0.5 text-sm bp3-icon bp3-icon-download" />
				</button>
			</div>
			<InfiniteProgress isLoading={isLoading} isSpacedOut={false} />
			<table className="w-full h-full border border-gray-400 table-auto rounded-md font-redhat-text overflow-auto border-collapse text-center">
				<thead>
					<tr>
						{headers.map((label) => (
							<th
								key={label}
								className="px-3 py-3 text-sm border font-medium leading-4 tracking-wide text-center text-gray-700 bg-gray-100 border-b border-gray-300"
							>
								{label}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{data.map((row, index) => (
						<tr
							key={row._id}
							className={
								row.bfl2RecordCount === 0 ? "border-2 border-red-500" : ""
							}
						>
							<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
								{index + 1}
							</td>
							<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
								{row.imoNumber}
							</td>
							<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
								{row.vesselName}
							</td>
							<td className="px-1 text-center py-3 text-[8px] lg:text-xs xl:text-[12px] border leading-4 tracking-wide border-b border-gray-300 font-redhat-text text-[#2D2D2D]">
								{row.bfl2RecordCount}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default Biofouling2Table;
